@file:Suppress("MagicNumber")

package com.nonopn.skydome.common.app.pages.certfoudr

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.pages.probes.PdfBlockedNotice
import com.nonopn.skydome.common.app.pages.probes.rememberProbeAccess
import com.nonopn.skydome.common.app.pages.main.model.DocumentHistoryItem
import com.nonopn.skydome.common.app.pages.main.model.DocumentHistoryType
import com.nonopn.skydome.common.app.pages.pdf.PdfHtmlBuilder
import com.nonopn.skydome.common.app.pages.pdf.PdfLangPickerDialog
import com.nonopn.skydome.common.app.pages.pdf.PdfOutputLang
import com.nonopn.skydome.common.app.pages.sharing.ShareManager
import com.nonopn.skydome.common.app.utils.fmt
import com.nonopn.skywatcher.maps.MapUtils
import com.nonopn.skywatcher.maps.providers.GoogleProvider
import com.nonopn.skydome.common.app.pages.fullscreenmap.FullscreenMapContainer
import com.nonopn.skydome.common.app.pages.fullscreenmap.MapZoomControls
import ovh.plrapps.mapcompose.api.addLayer
import ovh.plrapps.mapcompose.api.addMarker
import ovh.plrapps.mapcompose.api.addPath
import ovh.plrapps.mapcompose.api.scale
import ovh.plrapps.mapcompose.api.snapScrollTo
import ovh.plrapps.mapcompose.core.TileStreamProvider
import ovh.plrapps.mapcompose.ui.MapUI
import ovh.plrapps.mapcompose.ui.state.MapState

import korlibs.time.DateTime

import androidx.compose.ui.text.input.KeyboardType
import kotlinx.coroutines.launch
import kotlin.math.PI
import kotlin.math.abs
import kotlin.math.cos
import org.jetbrains.compose.resources.stringResource
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.cert_add_observations
import com.nonopn.skywatcher.common.app.res.cert_current_case
import com.nonopn.skywatcher.common.app.res.cert_current_case_pct
import com.nonopn.skywatcher.common.app.res.cert_electromagnetic_effects
import com.nonopn.skywatcher.common.app.res.cert_foudr_date_time
import com.nonopn.skywatcher.common.app.res.cert_foudr_distance
import com.nonopn.skywatcher.common.app.res.cert_foudr_intensity
import com.nonopn.skywatcher.common.app.res.cert_foudr_network
import com.nonopn.skywatcher.common.app.res.cert_foudr_screen_title
import com.nonopn.skywatcher.common.app.res.cert_foudr_studied_site
import com.nonopn.skywatcher.common.app.res.cert_foudr_subtitle
import com.nonopn.skywatcher.common.app.res.cert_foudr_type_label
import com.nonopn.skywatcher.common.app.res.cert_foudr_cloud_ground
import com.nonopn.skywatcher.common.app.res.cert_incidence_direct_indirect
import com.nonopn.skywatcher.common.app.res.cert_incidence_indirect_only
import com.nonopn.skywatcher.common.app.res.cert_incidence_probability_desc
import com.nonopn.skywatcher.common.app.res.cert_incidence_probability_title
import com.nonopn.skywatcher.common.app.res.cert_incidence_unlikely
import com.nonopn.skywatcher.common.app.res.cert_physical_damage
import com.nonopn.skywatcher.common.app.res.cert_reco_check_equipment
import com.nonopn.skywatcher.common.app.res.cert_reco_inspect
import com.nonopn.skywatcher.common.app.res.cert_reco_insurance
import com.nonopn.skywatcher.common.app.res.cert_reco_monitoring
import com.nonopn.skywatcher.common.app.res.cert_reco_no_action
import com.nonopn.skywatcher.common.app.res.cert_reco_surge_protectors
import com.nonopn.skywatcher.common.app.res.cert_reco_verify

private const val MAP_LEVEL_COUNT = 18
private val MAP_FULL_SIZE = 256 shl MAP_LEVEL_COUNT

private object Colors {
    val Background = Color(0xFFF5F7FA)
    val Surface = Color.White
    val Primary = Color(0xFF2B7FE0)
    val Heading = Color(0xFF1A2B4A)
    val Muted = Color(0xFF6B7A99)
    val Subtle = Color(0xFF9BA3B2)
    val CgNeg = Color(0xFF2B7FE0)
    val CgPos = Color(0xFFE63B2E)
    val Accent = Color(0xFFF5A800)
    val DangerHiBg = Color(0xFFFFEBEE)
    val DangerHiBorder = Color(0xFFE63B2E)
    val DangerHiText = Color(0xFFB71C1C)
    val DangerMidBg = Color(0xFFFFF3E0)
    val DangerMidBorder = Color(0xFFF5A800)
    val DangerMidText = Color(0xFFE65100)
    val DangerLoBg = Color(0xFFE8F5E9)
    val DangerLoBorder = Color(0xFF4CAF50)
    val DangerLoText = Color(0xFF2E7D32)
    val CardBorder = Color(0xFFE0E6F0)
    val TagBg = Color(0xFFEEF4FF)
}

/**
 * Lightning strike certificate screen — aligned with validated template.
 * Sections: site header, map, impact grid, probability, seuils grid,
 * incidence cards (direct/indirect), interpretation, recommendations, normes.
 */
@Suppress("LongMethod", "LongParameterList")
@Composable
fun CertFoudrScreen(
    modifier: Modifier = Modifier,
    projectName: String,
    projectUuid: String,
    projectLat: Double,
    projectLon: Double,
    impactLat: Double,
    impactLon: Double,
    impactTimestamp: Long,
    impactAmplitude: Int,
    impactPercent: Double,
    impactExternalId: String,
    shareManager: ShareManager,
    appModel: AppModel,
) {
    val absKa = abs(impactAmplitude.toDouble()) / 1000.0
    val isPositive = impactAmplitude > 0
    val polarity = if (isPositive) "CG+" else "CG\u2212"
    val polarityColor = if (isPositive) Colors.CgPos else Colors.CgNeg
    val distKm = MapUtils.distance(projectLat, projectLon, impactLat, impactLon)
    val dt = DateTime.fromUnixMillis(impactTimestamp * 1000L).local
    val dateLabel = "${dt.dayOfMonth.toString().padStart(2, '0')}/" +
        "${dt.month1.toString().padStart(2, '0')}/${dt.yearInt}"
    val timeLabel = "${dt.hours.toString().padStart(2, '0')}:" +
        dt.minutes.toString().padStart(2, '0')
    val pctInt = impactPercent.toInt()
    val kaStr = absKa.fmt(1)
    val distStr = if (distKm < 1.0) {
        "${(distKm * 1000).toInt()} m"
    } else {
        distKm.fmt(1) + " km"
    }

    // Danger level
    val dangerLevel = when {
        impactPercent >= 80 -> DangerLevel.HIGH
        impactPercent >= 30 -> DangerLevel.MODERATE
        else -> DangerLevel.LOW
    }

    var freeObservations by remember { mutableStateOf("") }

    Column(
        modifier = modifier
            .fillMaxSize()
            .background(Colors.Background)
            .verticalScroll(rememberScrollState())
            .padding(16.dp)
    ) {
        // ── SITE HEADER ──
        SiteHeader(
            projectName = projectName,
            latitude = projectLat,
            longitude = projectLon,
        )

        Spacer(Modifier.height(16.dp))

        // ── MAP ──
        SectionTitle("Localisation")
        ImpactDistanceMapSection(
            modifier = Modifier.fillMaxWidth(),
            projectLat = projectLat,
            projectLon = projectLon,
            impactLat = impactLat,
            impactLon = impactLon,
            distStr = distStr,
        )

        Spacer(Modifier.height(16.dp))

        // ── IMPACT DATA GRID ──
        SectionTitle("Donn\u00e9es de l\u2019impact")
        ImpactDataGrid(
            externalId = impactExternalId,
            dateLabel = dateLabel,
            timeLabel = timeLabel,
            distStr = distStr,
            kaStr = kaStr,
            polarity = polarity,
            polarityColor = polarityColor,
        )

        Spacer(Modifier.height(16.dp))

        // ── PROBABILITY BLOCK ──
        SectionTitle("Probabilit\u00e9 d\u2019incidence")
        ProbabilityBlock(
            pctInt = pctInt,
            dangerLevel = dangerLevel,
        )

        Spacer(Modifier.height(16.dp))

        // ── SEUILS GRID ──
        SectionTitle("Grille d\u2019interpr\u00e9tation des seuils")
        SeuilsGrid(dangerLevel = dangerLevel)

        Spacer(Modifier.height(16.dp))

        // ── INCIDENCE CARDS ──
        SectionTitle("Niveaux d\u2019incidence")
        IncidenceCards(
            pctInt = pctInt,
            dangerLevel = dangerLevel,
        )

        Spacer(Modifier.height(16.dp))

        // ── INTERPRETATION ──
        SectionTitle("Commentaire contextuel")
        InterpretationBlock(
            pctInt = pctInt,
            distStr = distStr,
            kaStr = kaStr,
            polarity = polarity,
        )

        Spacer(Modifier.height(16.dp))

        // ── RECOMMENDATIONS ──
        SectionTitle("Plan d\u2019action recommand\u00e9")
        RecommendationsBlock(dangerLevel = dangerLevel)

        Spacer(Modifier.height(16.dp))

        // ── FREE OBSERVATIONS ──
        SectionTitle("Observations libres")
        Card(
            colors = CardDefaults.cardColors(containerColor = Colors.Surface),
            shape = RoundedCornerShape(10.dp),
            elevation = CardDefaults.cardElevation(2.dp),
        ) {
            Column(Modifier.fillMaxWidth().padding(16.dp)) {
                OutlinedTextField(
                    value = freeObservations,
                    onValueChange = { freeObservations = it },
                    label = { Text(stringResource(Res.string.cert_add_observations)) },
                    modifier = Modifier.fillMaxWidth().heightIn(min = 100.dp),
                    maxLines = 8,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Text),
                )
            }
        }

        Spacer(Modifier.height(16.dp))

        // ── PDF EXPORT ──
        PdfExportSection(
            projectName = projectName,
            projectUuid = projectUuid,
            projectLat = projectLat,
            projectLon = projectLon,
            impactLat = impactLat,
            impactLon = impactLon,
            impactTimestamp = impactTimestamp,
            impactAmplitude = impactAmplitude,
            impactPercent = impactPercent,
            impactExternalId = impactExternalId,
            shareManager = shareManager,
            appModel = appModel,
        )

        Spacer(Modifier.height(12.dp))

        // ── NORMES ──
        Text(
            modifier = Modifier.fillMaxWidth(),
            text = "IEC 62305-2:2024 \u00b7 NF C 17-102:2011\nGLD360+ \u00b7 Strike Radar",
            fontSize = 11.sp,
            color = Colors.Subtle,
            textAlign = TextAlign.Center,
        )

        Spacer(Modifier.height(16.dp))
    }
}

// ── COMPOSABLES ────────────────────────────────────────────────────────

@Composable
private fun SiteHeader(
    projectName: String,
    latitude: Double,
    longitude: Double,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Text(
            text = stringResource(Res.string.cert_foudr_screen_title),
            fontSize = 18.sp,
            fontWeight = FontWeight.Bold,
            color = Colors.Heading,
        )
        Spacer(Modifier.height(2.dp))
        Text(
            text = stringResource(Res.string.cert_foudr_subtitle),
            fontSize = 13.sp,
            color = Colors.Muted,
        )
        Spacer(Modifier.height(10.dp))
        Text(
            text = projectName,
            fontSize = 22.sp,
            fontWeight = FontWeight.Bold,
            color = Colors.Heading,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(6.dp))
        Text(
            text = stringResource(Res.string.cert_foudr_studied_site),
            fontSize = 11.sp,
            fontWeight = FontWeight.SemiBold,
            color = Colors.Primary,
            letterSpacing = 0.5.sp,
        )
        Spacer(Modifier.height(2.dp))
        Text(
            text = "${latitude.fmt(4)}° N  ·  ${longitude.fmt(4)}°",
            fontSize = 13.sp,
            color = Colors.Muted,
            letterSpacing = 0.5.sp,
        )
    }
}

@Composable
private fun SectionTitle(title: String) {
    Text(
        text = title.uppercase(),
        fontSize = 12.sp,
        fontWeight = FontWeight.SemiBold,
        color = Colors.Primary,
        letterSpacing = 0.8.sp,
    )
    Spacer(Modifier.height(8.dp))
}

@Composable
private fun ImpactDataGrid(
    externalId: String,
    dateLabel: String,
    timeLabel: String,
    distStr: String,
    kaStr: String,
    polarity: String,
    polarityColor: Color,
) {
    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            ImpactCell(
                modifier = Modifier.weight(1f),
                label = "ID GLD360+",
                value = externalId,
            )
            ImpactCell(
                modifier = Modifier.weight(1f),
                label = stringResource(Res.string.cert_foudr_date_time),
                value = "$dateLabel \u00b7 $timeLabel",
            )
            ImpactCell(
                modifier = Modifier.weight(1f),
                label = stringResource(Res.string.cert_foudr_distance),
                value = distStr,
                valueColor = Colors.Accent,
            )
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            ImpactCell(
                modifier = Modifier.weight(1f),
                label = stringResource(Res.string.cert_foudr_intensity),
                value = "$kaStr kA  $polarity",
                valueColor = polarityColor,
            )
            ImpactCell(
                modifier = Modifier.weight(1f),
                label = stringResource(Res.string.cert_foudr_network),
                value = "GLD360+",
            )
            ImpactCell(
                modifier = Modifier.weight(1f),
                label = stringResource(Res.string.cert_foudr_type_label),
                value = stringResource(Res.string.cert_foudr_cloud_ground),
            )
        }
    }
}

@Composable
private fun ImpactCell(
    modifier: Modifier = Modifier,
    label: String,
    value: String,
    valueColor: Color = Colors.Heading,
) {
    Column(
        modifier = modifier
            .clip(RoundedCornerShape(8.dp))
            .background(Colors.Background)
            .border(1.dp, Colors.CardBorder, RoundedCornerShape(8.dp))
            .padding(9.dp),
    ) {
        Text(
            text = label,
            fontSize = 10.sp,
            fontWeight = FontWeight.SemiBold,
            color = Colors.Muted,
            letterSpacing = 0.5.sp,
        )
        Spacer(Modifier.height(3.dp))
        Text(
            text = value,
            fontSize = 14.sp,
            fontWeight = FontWeight.SemiBold,
            color = valueColor,
        )
    }
}

@Composable
private fun ProbabilityBlock(
    pctInt: Int,
    dangerLevel: DangerLevel,
) {
    val bg = dangerLevel.bg
    val border = dangerLevel.border
    val textColor = dangerLevel.text

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(10.dp))
            .border(2.dp, border, RoundedCornerShape(10.dp))
            .background(bg)
            .padding(20.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(20.dp),
    ) {
        Text(
            text = "$pctInt %",
            fontSize = 48.sp,
            fontWeight = FontWeight.ExtraBold,
            color = textColor,
        )
        Column {
            Text(
                text = stringResource(Res.string.cert_incidence_probability_title),
                fontSize = 16.sp,
                fontWeight = FontWeight.SemiBold,
                color = Colors.Heading,
            )
            Spacer(Modifier.height(2.dp))
            Text(
                text = stringResource(Res.string.cert_incidence_probability_desc),
                fontSize = 12.sp,
                color = Colors.Muted,
                lineHeight = 16.sp,
            )
        }
    }
}

@Composable
private fun SeuilsGrid(dangerLevel: DangerLevel) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        SeuilCard(
            modifier = Modifier.weight(1f),
            range = "\u2265 80 %",
            label = stringResource(Res.string.cert_incidence_direct_indirect),
            desc = "Canal plasma sur le site possible. " +
                "Risques physiques imm\u00e9diats. " +
                "Surtensions LEMP quasi-certaines.",
            level = DangerLevel.HIGH,
            isActive = dangerLevel == DangerLevel.HIGH,
        )
        SeuilCard(
            modifier = Modifier.weight(1f),
            range = "30 \u2013 79 %",
            label = stringResource(Res.string.cert_incidence_indirect_only),
            desc = "Surtensions LEMP probables. " +
                "Automates et \u00e9quipements sensibles expos\u00e9s.",
            level = DangerLevel.MODERATE,
            isActive = dangerLevel == DangerLevel.MODERATE,
        )
        SeuilCard(
            modifier = Modifier.weight(1f),
            range = "< 30 %",
            label = stringResource(Res.string.cert_incidence_unlikely),
            desc = "Impact \u00e9loign\u00e9 du site. " +
                "Perturbations mineures possibles uniquement " +
                "pour \u00e9quipements tr\u00e8s sensibles.",
            level = DangerLevel.LOW,
            isActive = dangerLevel == DangerLevel.LOW,
        )
    }
}

@Composable
private fun SeuilCard(
    modifier: Modifier = Modifier,
    range: String,
    label: String,
    desc: String,
    level: DangerLevel,
    isActive: Boolean,
) {
    val borderWidth = if (isActive) 2.dp else 1.dp
    Column(
        modifier = modifier
            .clip(RoundedCornerShape(8.dp))
            .border(borderWidth, level.border, RoundedCornerShape(8.dp))
            .background(level.bg)
            .padding(9.dp),
    ) {
        Text(
            text = range,
            fontSize = 15.sp,
            fontWeight = FontWeight.Bold,
            color = level.text,
        )
        Spacer(Modifier.height(3.dp))
        Text(
            text = label,
            fontSize = 11.sp,
            fontWeight = FontWeight.SemiBold,
            color = Colors.Heading,
            lineHeight = 14.sp,
        )
        Spacer(Modifier.height(3.dp))
        Text(
            text = desc,
            fontSize = 10.sp,
            color = Colors.Muted,
            lineHeight = 13.sp,
        )
        if (isActive) {
            Spacer(Modifier.height(4.dp))
            Text(
                text = stringResource(Res.string.cert_current_case),
                fontSize = 10.sp,
                fontWeight = FontWeight.Bold,
                color = level.text,
            )
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun IncidenceCards(
    pctInt: Int,
    dangerLevel: DangerLevel,
) {
    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
        // Direct incidence card
        IncidenceCard(
            badge = "\u2265 80 % \u2014 Directe et/ou indirecte",
            title = stringResource(Res.string.cert_physical_damage),
            seuil = "Seuil : probabilit\u00e9 \u2265 80 %",
            description = "Le canal plasma a tr\u00e8s probablement atteint " +
                "une structure du site. Les effets sont imm\u00e9diats " +
                "et potentiellement graves : destruction de mat\u00e9riel, " +
                "d\u00e9part d\u2019incendie, risque vital.",
            tags = listOf(
                "\uD83D\uDD25 Incendie",
                "\uD83D\uDCA5 Destruction",
                "\u26A0\uFE0F Risque vital",
                "\uD83C\uDFD7\uFE0F Dommages structurels",
            ),
            isDirect = true,
            isActive = dangerLevel == DangerLevel.HIGH,
            pctInt = pctInt,
        )

        // Indirect incidence card
        IncidenceCard(
            badge = "30\u201379 % \u2014 Indirecte probable",
            title = stringResource(Res.string.cert_electromagnetic_effects),
            seuil = "Seuil : probabilit\u00e9 30 \u2013 79 %",
            description = "Le coup de foudre est suffisamment proche " +
                "et \u00e9nerg\u00e9tique pour g\u00e9n\u00e9rer des " +
                "surtensions d\u2019induction (LEMP) sur les r\u00e9seaux " +
                "\u00e9lectriques et de communication.",
            tags = listOf(
                "\u26A1 Surtensions LEMP",
                "\uD83D\uDD0C Automates",
                "\uD83D\uDCE1 SCADA / IoT",
                "\uD83D\uDCBB Informatique",
            ),
            isDirect = false,
            isActive = dangerLevel == DangerLevel.MODERATE,
            pctInt = pctInt,
        )
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun IncidenceCard(
    badge: String,
    title: String,
    seuil: String,
    description: String,
    tags: List<String>,
    isDirect: Boolean,
    isActive: Boolean,
    pctInt: Int,
) {
    val borderColor = if (isDirect) Colors.DangerHiBorder else Colors.Accent
    val bg = if (isDirect) Colors.DangerHiBg else Colors.DangerMidBg
    val badgeBg = if (isDirect) Colors.DangerHiBorder else Colors.Accent
    val borderWidth = if (isActive) 3.dp else 2.dp

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(10.dp))
            .border(borderWidth, borderColor, RoundedCornerShape(10.dp))
            .background(bg)
            .padding(14.dp),
    ) {
        if (isActive) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Canvas(Modifier.size(8.dp)) {
                    drawCircle(Color(0xFFF5A800))
                }
                Spacer(Modifier.width(5.dp))
                Text(
                    text = stringResource(Res.string.cert_current_case_pct, pctInt.toString()),
                    fontSize = 12.sp,
                    fontWeight = FontWeight.Bold,
                    color = Colors.Accent,
                )
            }
            Spacer(Modifier.height(6.dp))
        }
        Text(
            modifier = Modifier
                .clip(RoundedCornerShape(4.dp))
                .background(badgeBg)
                .padding(horizontal = 10.dp, vertical = 3.dp),
            text = badge,
            fontSize = 11.sp,
            fontWeight = FontWeight.Bold,
            color = Color.White,
        )
        Spacer(Modifier.height(8.dp))
        Text(
            text = title,
            fontSize = 14.sp,
            fontWeight = FontWeight.Bold,
            color = Colors.Heading,
        )
        Spacer(Modifier.height(4.dp))
        Text(
            text = seuil,
            fontSize = 12.sp,
            fontWeight = FontWeight.SemiBold,
            color = Colors.Muted,
        )
        Spacer(Modifier.height(6.dp))
        Text(
            text = description,
            fontSize = 13.sp,
            color = Colors.Heading,
            lineHeight = 19.sp,
        )
        Spacer(Modifier.height(8.dp))
        FlowRow(
            horizontalArrangement = Arrangement.spacedBy(5.dp),
            verticalArrangement = Arrangement.spacedBy(5.dp),
        ) {
            tags.forEach { tag ->
                Text(
                    modifier = Modifier
                        .clip(RoundedCornerShape(4.dp))
                        .background(Color(0x12000000))
                        .padding(horizontal = 8.dp, vertical = 3.dp),
                    text = tag,
                    fontSize = 11.sp,
                    fontWeight = FontWeight.SemiBold,
                    color = Colors.Heading,
                )
            }
        }
    }
}

@Composable
private fun InterpretationBlock(
    pctInt: Int,
    distStr: String,
    kaStr: String,
    polarity: String,
) {
    val text = when {
        pctInt >= 80 -> buildHighInterpretation(pctInt, distStr, kaStr, polarity)
        pctInt >= 30 -> buildMidInterpretation(pctInt, distStr, kaStr, polarity)
        else -> buildLowInterpretation(pctInt, distStr, kaStr)
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(10.dp))
            .border(1.dp, Color(0xFFD0DFEF), RoundedCornerShape(10.dp))
            .background(Color(0xFFF8FAFF))
            .padding(16.dp),
    ) {
        Text(
            text = text,
            fontSize = 14.sp,
            color = Colors.Heading,
            lineHeight = 21.sp,
        )
    }
}

@Composable
private fun RecommendationsBlock(dangerLevel: DangerLevel) {
    Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
        when (dangerLevel) {
            DangerLevel.HIGH -> {
                RecoItem(
                    priority = "URGENT",
                    text = stringResource(Res.string.cert_reco_inspect),
                    level = DangerLevel.HIGH,
                )
                RecoItem(
                    priority = "URGENT",
                    text = stringResource(Res.string.cert_reco_check_equipment),
                    level = DangerLevel.HIGH,
                )
                RecoItem(
                    priority = "PRIORIT\u00c9 2",
                    text = stringResource(Res.string.cert_reco_insurance),
                    level = DangerLevel.MODERATE,
                )
            }
            DangerLevel.MODERATE -> {
                RecoItem(
                    priority = "URGENT",
                    text = stringResource(Res.string.cert_reco_verify),
                    level = DangerLevel.HIGH,
                )
                RecoItem(
                    priority = "PRIORIT\u00c9 2",
                    text = stringResource(Res.string.cert_reco_surge_protectors),
                    level = DangerLevel.MODERATE,
                )
            }
            DangerLevel.LOW -> {
                RecoItem(
                    priority = "CONSEIL",
                    text = stringResource(Res.string.cert_reco_no_action),
                    level = DangerLevel.LOW,
                )
            }
        }
        RecoItem(
            priority = "CONSEIL",
            text = stringResource(Res.string.cert_reco_monitoring),
            level = DangerLevel.LOW,
        )
    }
}

@Composable
private fun RecoItem(
    priority: String,
    text: String,
    level: DangerLevel,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(8.dp))
            .border(1.dp, level.border.copy(alpha = 0.5f), RoundedCornerShape(8.dp))
            .background(level.bg)
            .padding(9.dp),
        horizontalArrangement = Arrangement.spacedBy(10.dp),
        verticalAlignment = Alignment.Top,
    ) {
        Text(
            modifier = Modifier
                .clip(RoundedCornerShape(3.dp))
                .background(level.border)
                .padding(horizontal = 7.dp, vertical = 2.dp),
            text = priority,
            fontSize = 10.sp,
            fontWeight = FontWeight.Bold,
            color = Color.White,
        )
        Text(
            text = text,
            fontSize = 13.sp,
            color = Colors.Heading,
            lineHeight = 18.sp,
        )
    }
}

@Suppress("LongParameterList")
@Composable
private fun PdfExportSection(
    projectName: String,
    projectUuid: String,
    projectLat: Double,
    projectLon: Double,
    impactLat: Double,
    impactLon: Double,
    impactTimestamp: Long,
    impactAmplitude: Int,
    impactPercent: Double,
    impactExternalId: String,
    shareManager: ShareManager,
    appModel: AppModel,
) {
    var showLangPicker by remember { mutableStateOf(false) }
    // PDF exports need a paid probe when only trial probes cover the site
    val probeAccess = rememberProbeAccess(appModel, projectLat, projectLon)
    if (probeAccess.pdfBlocked) {
        PdfBlockedNotice(Modifier.padding(bottom = 8.dp))
    }

    Button(
        modifier = Modifier.fillMaxWidth().height(48.dp),
        onClick = { showLangPicker = true },
        enabled = !probeAccess.pdfBlocked,
        colors = ButtonDefaults.buttonColors(containerColor = Colors.Primary),
    ) {
        Text(
            "\uD83D\uDCE5 Exporter en PDF",
            color = Color.White,
            fontWeight = FontWeight.Bold,
        )
    }

    if (showLangPicker) {
        PdfLangPickerDialog(
            currentLang = PdfOutputLang.FR,
            onLangSelected = { lang ->
                showLangPicker = false
                val now = DateTime.now().local
                val genDate =
                    "${now.dayOfMonth.toString().padStart(2, '0')}/" +
                        "${now.month1.toString().padStart(2, '0')}/" +
                        "${now.yearInt}"
                val html = PdfHtmlBuilder.buildCertFoudr(
                    lang = lang,
                    projectName = projectName,
                    projectLat = projectLat,
                    projectLon = projectLon,
                    impactLat = impactLat,
                    impactLon = impactLon,
                    impactTimestamp = impactTimestamp,
                    impactAmplitude = impactAmplitude,
                    impactPercent = impactPercent,
                    impactExternalId = impactExternalId,
                    generatedDate = genDate,
                )
                shareManager.shareHtmlAsPdf(
                    "Certificat Foudroiement \u2014 $projectName",
                    html,
                )
                val nowMillis = DateTime.now().unixMillisLong
                appModel.recordDocumentHistory(
                    DocumentHistoryItem(
                        id = "cert_foudr_client_${projectUuid}_$nowMillis",
                        type = DocumentHistoryType.CERT_LIGHTNING,
                        siteName = projectName,
                        latitude = projectLat,
                        longitude = projectLon,
                        createdAtSecondsUtc = nowMillis / 1000L,
                        impactLat = impactLat,
                        impactLon = impactLon,
                        impactTimestamp = impactTimestamp,
                        impactAmplitude = impactAmplitude,
                        impactPercent = impactPercent,
                        impactExternalId = impactExternalId,
                    )
                )
            },
            onDismiss = { showLangPicker = false },
        )
    }
}

// ── MAP ────────────────────────────────────────────────────────────────

@Composable
private fun ImpactDistanceMapSection(
    modifier: Modifier = Modifier,
    projectLat: Double,
    projectLon: Double,
    impactLat: Double,
    impactLon: Double,
    distStr: String,
) {
    val midLat = (projectLat + impactLat) / 2.0
    val midLon = (projectLon + impactLon) / 2.0
    val kmPerDeg = 111.32
    val cosM = cos(midLat * PI / 180.0)
    val dLat = abs(projectLat - impactLat) * kmPerDeg
    val dLon = abs(projectLon - impactLon) * kmPerDeg * cosM
    val extent = maxOf(dLat, dLon).coerceAtLeast(0.2) * 1.8
    val googleApi = remember { GoogleProvider() }
    val tileStreamProvider = remember(googleApi) {
        TileStreamProvider { row, col, zoomLvl ->
            googleApi.getTile(row, col, zoomLvl)
        }
    }
    val center = remember { MapUtils.latLngToXY(midLat, midLon) }
    val scope = rememberCoroutineScope()
    val density = LocalDensity.current
    val mapState = remember {
        val vpPx = with(density) { 360.dp.toPx() }
        val xRange = 2.0 * extent / (40075.0 * cosM)
        MapState(
            levelCount = MAP_LEVEL_COUNT,
            fullWidth = MAP_FULL_SIZE,
            fullHeight = MAP_FULL_SIZE,
            tileSize = 256,
        ) {
            scroll(center.x, center.y)
        }.apply {
            scale = vpPx / (MAP_FULL_SIZE.toDouble() * xRange)
        }
    }
    LaunchedEffect(Unit) {
        googleApi.initialize()
        mapState.addLayer(tileStreamProvider)
        val projXY = MapUtils.latLngToXY(projectLat, projectLon)
        val impXY = MapUtils.latLngToXY(impactLat, impactLon)
        try {
            mapState.addPath(
                id = "line", width = 3.dp, color = Color.White,
            ) {
                addPoints(listOf(projXY.toPair(), impXY.toPair()))
            }
        } catch (_: Throwable) { }
        try {
            mapState.addMarker("site", projXY.x, projXY.y) {
                Canvas(Modifier.size(32.dp)) {
                    val cx = size.width / 2
                    val cy = size.height / 2
                    drawCircle(Color(0xFF2B7FE0), radius = 16f, center = Offset(cx, cy))
                    drawCircle(Color.White, radius = 6f, center = Offset(cx, cy))
                }
            }
        } catch (_: Throwable) { }
        try {
            mapState.addMarker("impact", impXY.x, impXY.y) {
                Canvas(Modifier.size(32.dp)) {
                    drawCircle(
                        Color(0xFFE63B2E),
                        radius = 16f,
                        center = Offset(size.width / 2, size.height / 2),
                    )
                }
            }
        } catch (_: Throwable) { }
    }
    Card(
        modifier = modifier,
        colors = CardDefaults.cardColors(containerColor = Colors.Surface),
        shape = RoundedCornerShape(10.dp),
        elevation = CardDefaults.cardElevation(2.dp),
    ) {
        Column(Modifier.padding(12.dp)) {
            FullscreenMapContainer(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(360.dp)
                    .clip(RoundedCornerShape(10.dp)),
                controls = { isFullscreen -> if (isFullscreen) MapZoomControls(mapState) },
            ) { isFullscreen ->
                MapUI(
                    modifier = Modifier.fillMaxSize(),
                    state = mapState,
                )
                // Transparent overlay to disable all map gestures (inline only, the full screen map is interactive)
                if (!isFullscreen) {
                    Box(
                        modifier = Modifier.fillMaxSize()
                            .pointerInput(Unit) { /* consume all touch events */ }
                    )
                }
            }
            Spacer(Modifier.height(8.dp))
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(4.dp),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Canvas(modifier = Modifier.size(10.dp)) {
                            drawCircle(Color(0xFF2B7FE0))
                        }
                        Text("Site", fontSize = 11.sp, color = Colors.Muted)
                    }
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(4.dp),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Canvas(modifier = Modifier.size(10.dp)) {
                            drawCircle(Color(0xFFE63B2E))
                        }
                        Text("Impact", fontSize = 11.sp, color = Colors.Muted)
                    }
                }
                Text(
                    distStr,
                    fontSize = 12.sp,
                    fontWeight = FontWeight.Bold,
                    color = Colors.Heading,
                )
            }
        }
    }
}

@Composable
private fun MapControlButton(label: String, onClick: () -> Unit) {
    Box(
        Modifier
            .size(32.dp)
            .clip(RoundedCornerShape(6.dp))
            .background(Color.White.copy(alpha = 0.9f))
            .border(1.dp, Color(0xFFCCCCCC), RoundedCornerShape(6.dp))
            .clickable { onClick() },
        contentAlignment = Alignment.Center,
    ) {
        Text(
            label,
            fontSize = 16.sp,
            fontWeight = FontWeight.Bold,
            color = Colors.Heading,
        )
    }
}

// ── DATA & HELPERS ─────────────────────────────────────────────────────

private enum class DangerLevel(
    val bg: Color,
    val border: Color,
    val text: Color,
) {
    HIGH(
        bg = Color(0xFFFFEBEE),
        border = Color(0xFFE63B2E),
        text = Color(0xFFB71C1C),
    ),
    MODERATE(
        bg = Color(0xFFFFF3E0),
        border = Color(0xFFF5A800),
        text = Color(0xFFE65100),
    ),
    LOW(
        bg = Color(0xFFE8F5E9),
        border = Color(0xFF4CAF50),
        text = Color(0xFF2E7D32),
    ),
}

private fun buildHighInterpretation(
    pctInt: Int, distStr: String, kaStr: String, polarity: String,
): String = "La probabilit\u00e9 d\u2019incidence directe et/ou indirecte de " +
    "ce coup de foudre sur le site est \u00e9lev\u00e9e ($pctInt %). " +
    "\u00c0 une distance de $distStr avec une intensit\u00e9 de $kaStr kA " +
    "($polarity), le risque de dommages physiques directs ou d\u2019effets " +
    "induits (surtensions, couplage \u00e9lectromagn\u00e9tique) est significatif." +
    "\n\nUne inspection d\u00e9taill\u00e9e des \u00e9quipements et syst\u00e8mes " +
    "de protection est recommand\u00e9e conform\u00e9ment \u00e0 l\u2019IEC 62305-2:2024."

private fun buildMidInterpretation(
    pctInt: Int, distStr: String, kaStr: String, polarity: String,
): String = "La probabilit\u00e9 d\u2019incidence est mod\u00e9r\u00e9e ($pctInt %). " +
    "\u00c0 une distance de $distStr avec une intensit\u00e9 de $kaStr kA " +
    "($polarity), les dommages physiques directs sont peu probables. " +
    "Cependant, les effets indirects tels que les surtensions induites " +
    "ou les perturbations \u00e9lectromagn\u00e9tiques restent probables." +
    "\n\nLa v\u00e9rification des dispositifs de protection contre les " +
    "surtensions est recommand\u00e9e."

private fun buildLowInterpretation(
    pctInt: Int, distStr: String, kaStr: String,
): String = "La probabilit\u00e9 d\u2019incidence directe et/ou indirecte est " +
    "faible ($pctInt %). \u00c0 une distance de $distStr avec une intensit\u00e9 " +
    "de $kaStr kA, les dommages physiques directs et les effets indirects " +
    "sont peu probables pour cet \u00e9v\u00e9nement sp\u00e9cifique." +
    "\n\nAucune action imm\u00e9diate n\u2019est requise sur la base de " +
    "cet \u00e9v\u00e9nement seul."
